import React, { FC, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { BusinessCardsFirestoreResponse } from 'src/types';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Card, Spinner } from '../../../../components';
import { useGetBusinessCardsFromFirestore, useQueryHelper } from '../../../../queries';
import { useLanguageState } from '../../../../state';

interface BusinessCardsProps {
  id: string;
}

export const BusinessCards: FC<BusinessCardsProps> = ({ id }) => {
  const hotelEventsCollections = useGetBusinessCardsFromFirestore(id);
  const navigate = useNavigate();
  const { data: businessCards } = hotelEventsCollections;
  const { isLoading, isError } = useQueryHelper({ queries: [hotelEventsCollections] });
  const { language: currentLang } = useLanguageState();

  const sortedBusinessData = businessCards?.sort((a, b) => {
    const hasOrderA = a?.order !== undefined && a?.order !== null;
    const hasOrderB = b?.order !== undefined && b?.order !== null;

    if (hasOrderA && hasOrderB) {
      return a.order! - b.order!;
    }
    if (hasOrderA && !hasOrderB) {
      return -1;
    }
    if (!hasOrderA && hasOrderB) {
      return 1;
    }

    const dateA = a?.createdAt ? new Date(a.createdAt.toDate()) : null;
    const dateB = b?.createdAt ? new Date(b.createdAt.toDate()) : null;

    if (!dateA || !dateB) {
      return 0;
    }
    return dateA.getTime() - dateB.getTime();
  });

  if (isLoading) {
    return <Spinner global />;
  }

  if (isError) {
    return (<>error</>);
  }

  return (
    <Fragment key="business-cards">
      <Swiper
        spaceBetween={5}
        style={{ width: '100%' }}
        slidesPerView={1.2}
        lazy="true"
        loop
        centeredSlides
        breakpoints={{
          768: {
            slidesPerView: 3.2,
            centeredSlides: false,
          },
          1024: {
            slidesPerView: 3.4,
            centeredSlides: false,
          },
        }}
      >

        {sortedBusinessData && sortedBusinessData?.length
         > 0 && sortedBusinessData?.map((businessCard: BusinessCardsFirestoreResponse) => (
           <SwiperSlide
             key={businessCard.id}
           >
             <Card
               action={() => navigate(`/business/${businessCard?.id}`)}
               key={businessCard?.id}
               image={businessCard?.cover || ''}
               title={businessCard?.title?.[currentLang] || ''}
               description={businessCard?.description?.[currentLang] || ''}
             />
           </SwiperSlide>
        ))}
      </Swiper>
    </Fragment>
  );
};
